import { Component } from "react";
import React from "react";
import "./drop-down-input.scss";
import get from "lodash/get";
import { clearFields } from "redux-form";
import { classNames } from "react-extras";
import { breakpoint } from "../../../constants/css";

class DropDownInput extends Component {
  state = {
    openPopup: false,
    justOpened: true,
    mobileMode: false,
    leftSide: false,
    secondaryMenu: null,
  };

  constructor(props) {
    super(props);
    this.ref = React.createRef();
  }

  getDisplayName = value => {
    if (!Array.isArray(this.props.options)) {
      return this.props.label;
    }
    const currentOption = this.props.options.find(option => option.value === value);
    return get(currentOption, "label", this.props.label);
  };

  onClick = e => {
    this.setMobileMode();
    if (this.props.disabled) {
      return;
    }
    if (this.state.openPopup) {
      this.closePopup(e);
    } else {
      this.openPopup(e);
    }
  };

  openPopup = () => {
    this.setState({ openPopup: true, justOpened: true });
    window.addEventListener("click", this.closePopup);
  };

  closePopup = () => {
    if (this.state.justOpened) {
      this.setState({ justOpened: false });
    } else {
      this.setState({ openPopup: false, secondaryMenu: null });
      this.removeListener();
    }
  };

  removeListener = () => {
    window.removeEventListener("click", this.closePopup);
  };

  setMobileMode = () => {
    var rect;
    if (this.ref.current) {
      rect = this.ref.current.getBoundingClientRect();
    }
    this.setState({
      mobileMode: window.innerWidth < breakpoint,
      leftSide: rect && rect.left < window.innerWidth / 2,
    });
  };

  componentWillUnmount() {
    this.removeListener();
  }

  isEmptyState = () => {
    if (!Array.isArray(this.props.options)) {
      return true;
    }

    return this.props.options.find(option => option.value === this.props.input.value) === undefined;
  };

  renderOptions = () => {
    const blankOption = (
      <div
        key={"unselect-option"}
        onClick={e => {
          this.props.meta.dispatch(
            clearFields(this.props.meta.form, false, false, this.props.input.name)
          );
          this.props.input.onChange(null);
          this.closePopup(e);
        }}
        className={"drop-down-input__popup-item"}>
        All
      </div>
    );
    const options = this.props.options.map((option, index) => {
      return (
        <div
          key={option.label + index}
          onClick={e => {
            if (option.secondaryMenu) {
              e.preventDefault();
              e.stopPropagation();
              this.setState({
                secondaryMenu: () =>
                  option.secondaryMenu({
                    value: option.value,
                    onChange: this.props.input.onChange,
                    closePopup: this.closePopup,
                  }),
                openPopup: false,
              });
              return;
            }
            this.props.input.onChange(option.value);
            this.closePopup(e);
          }}
          className={"drop-down-input__popup-item"}>
          {option.label}
        </div>
      );
    });
    return this.props.noUnset ? options : [blankOption, ...options];
  };
  renderPopup = () => {
    if (!this.state.openPopup || !Array.isArray(this.props.options)) {
      return null;
    }
    return (
      <div className={`drop-down-input__popup ${this.isEmptyState() ? "selected" : "unselected"}`}>
        {this.renderOptions()}
      </div>
    );
  };
  renderSecondary = () => {
    if (!this.state.secondaryMenu) {
      return null;
    }
    return <div className={`drop-down-input__secondary-popup`}>{this.state.secondaryMenu()}</div>;
  };
  render() {
    return (
      <div
        ref={this.ref}
        className={classNames(
          "drop-down-input__container",
          this.isEmptyState() && "drop-down-input__container--empty",
          this.state.mobileMode && "drop-down-input__container--mobile",
          this.state.leftSide && "drop-down-input__container--left-side",
          this.props.disabled && "drop-down-input__container--disabled"
        )}
        onClick={this.onClick}>
        <span className="drop-down-input__label">
          {this.getDisplayName(this.props.input.value)}
        </span>
        {this.state.secondaryMenu && this.renderSecondary()}
        {this.renderPopup()}
      </div>
    );
  }
}

export default DropDownInput;
